import {
  useBlockedAccessDialog,
} from "~/services/blocked-access-dialog";
import {
  useDeletedAccountDialog,
} from "~/services/deleted-account-dialog";

let blockedAccessRequest: Promise<void> | null = null;

const joinUrl = (base: string, path: string): string => {
  if (!base) {
    return path;
  }
  if (base.endsWith("/") && path.startsWith("/")) {
    return `${base.slice(0, -1)}${path}`;
  }
  if (!base.endsWith("/") && !path.startsWith("/")) {
    return `${base}/${path}`;
  }
  return `${base}${path}`;
};

export const getApiErrorStatus = (error: unknown): number | undefined => {
  const apiError = error as any;
  return apiError?.response?.status ?? apiError?.statusCode ?? apiError?.status;
};

export const checkBlockedAccessAfterApiError = async (input: {
  error: unknown;
  token?: string | null;
  apiBaseUrl: string;
  apiBasePath: string;
  mockEnabled: boolean;
  requestPath: string;
}): Promise<void> => {
  const status = getApiErrorStatus(input.error);
  if (
    !input.token
    || input.mockEnabled
    || (status !== 401 && status !== 403)
    || input.requestPath === "/auth/access-status"
    || input.requestPath === "/api/auth/access-status"
  ) {
    return;
  }

  if (blockedAccessRequest) {
    return blockedAccessRequest;
  }

  blockedAccessRequest = (async () => {
    try {
      const response = await $fetch<{blocked: boolean; accessStatus: "active" | "blocked" | "deleted"}>(
        joinUrl(input.apiBaseUrl, joinUrl(input.apiBasePath, "/auth/access-status")),
        {
          headers: {
            Authorization: `Bearer ${input.token}`,
          },
        },
      );
      if (response.accessStatus === "deleted") {
        useDeletedAccountDialog();
      } else if (response.blocked) {
        useBlockedAccessDialog();
      }
    } catch {
      return;
    } finally {
      blockedAccessRequest = null;
    }
  })();

  return blockedAccessRequest;
};
